/*
 *
 *  * Copyright (c) 2022 AccelByte Inc. All Rights Reserved.
 *  * This is licensed software from AccelByte Inc, for limitations
 *  * and restrictions contact your company contract manager.
 *
 */

import React from "react";
import { Helmet } from "react-helmet";
import { GoogleTagManagerInit } from "../google-tag-manager/gtmInit";
import { t } from "../../utils/i18n/i18n";

interface Props {
  title?: string | undefined;
}

export class HeaderHelmet extends React.Component<Props> {
  render() {
    const { title } = this.props;
    const defaultTitle = t("Starbreeze.App.title");
    const helmetTitle = title || defaultTitle;

    return (
      <Helmet>
        <title>{helmetTitle}</title>
        {process.env.NODE_ENV !== "development" && window.self === window.top && <GoogleTagManagerInit />}
      </Helmet>
    );
  }
}
